/*
	Abre ou fecha o menu (reverte o estado)
*/
export default ({ commit }) => 
	commit("toggleMenu")

